import { SimpleFormValidationConfig, requiredValidation, validateEmail } from 'app/infrastructure/simple-form';
import { sfNames } from 'app/area/administration/edit/sf-names';

export const addUserValidationConfig: SimpleFormValidationConfig = [
  requiredValidation(sfNames.name),
  requiredValidation(sfNames.personId),
  requiredValidation(sfNames.userType),
  requiredValidation(sfNames.mainUserGroup),
  requiredValidation(sfNames.currentUserGroup),
  requiredValidation(sfNames.language),
  validateEmail(sfNames.emailAddress)
];

export const editUserValidationConfig: SimpleFormValidationConfig = [
  requiredValidation(sfNames.name),
  requiredValidation(sfNames.userType),
  requiredValidation(sfNames.mainUserGroup),
  requiredValidation(sfNames.currentUserGroup),
  requiredValidation(sfNames.language),
  validateEmail(sfNames.emailAddress)
];
